var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-window-component"},[_c('div',[_c('div',[_vm._t("content")],2),_vm._v(" "),_c('div',[_c('div',[(_vm.cancelable)?_c('button',{on:{"click":_vm.cancelClicked}},[_vm._v("CANCEL")]):_vm._e(),_vm._v(" "),_c('button',{on:{"click":_vm.okClicked}},[_vm._v("OK")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3916119e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editors/ModalWindow.vue
// module id = 642
// module chunks = 0